module.exports = __webpack_public_path__ + "img/pass.1bc97fdd.svg";